export default process.env.VUE_APP_ENI_GEOSERVER;
